module.exports = __webpack_public_path__ + "img/video.2f3bfa3f.png";